const videoElements = document.querySelectorAll( 'video' );

/**
 * Adds a simple play/pause controller to a video element if it does not already have controls set.
 *
 * @param {HTMLVideoElement} element Video element.
 */
const addController = ( element ) => {
	if ( element.getAttribute( 'controls' ) ) {
		return;
	}

	element.setAttribute( 'disablepictureinpicture', 'true' );
	element.setAttribute( 'disableremoteplayback', 'true' );
	element.setAttribute(
		'controlslist',
		'nodownload,nofullscreen,noremoteplayback'
	);

	const controllerButton = document.createElement( 'button' );
	const playEvent = () => {
		element.play();
	};
	const pauseEvent = () => {
		element.pause();
	};

	element.after( controllerButton );
	controllerButton.classList.add( 'c-video-control__button' );

	element.onplaying = () => {
		controllerButton.textContent = 'pause video';
		controllerButton.removeEventListener( 'click', playEvent );
		controllerButton.addEventListener( 'click', pauseEvent );
	};

	element.onpause = () => {
		controllerButton.textContent = 'play video';
		controllerButton.removeEventListener( 'click', pauseEvent );
		controllerButton.addEventListener( 'click', playEvent );
	};
};

/**
 *
 */
export const videoElementControllers = () => {
	[ ...videoElements ].map( addController );
};
